module.exports = __webpack_public_path__ + "media/img/blue-swirl-de1b9f9ac38af163ade4fd0dde9144e8.svg";